import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui-kit/dialog';
import { ByodApplication } from '../../types/byod.types';

interface ByodSpecsDialogProps {
  application: ByodApplication | null;
  onOpenChange: (open: boolean) => void;
}

export const ByodSpecsDialog = ({ application, onOpenChange }: ByodSpecsDialogProps) => {
  const { t } = useTranslation();

  const rows: [string, string | undefined][] = application
    ? [
        ['DEVICE_MODEL', application.DeviceModel],
        ['COMPUTER_PROCESSOR', application.ComputerProcessor],
        ['MOTHERBOARD', application.Motherboard],
        ['RAM_CAPACITY', application.RamCapacity],
        ['MONITOR_SPEC', application.MonitorDetails],
        ['STORAGE_SPEC', application.HddSsdDetails],
      ]
    : [];

  return (
    <Dialog open={Boolean(application)} onOpenChange={onOpenChange}>
      <DialogContent
        alignCloseWithTitle
        className="grid-cols-[minmax(0,1fr)] max-h-[90dvh] overflow-y-auto sm:max-w-md"
      >
        <DialogHeader className="pr-6">
          <DialogTitle className="break-words">{t('DEVICE_SPECS')}</DialogTitle>
        </DialogHeader>
        <dl className="grid grid-cols-1 gap-x-6 gap-y-3 text-sm sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-y-2">
          {rows.map(([labelKey, value]) => (
            <div key={labelKey} className="flex flex-col gap-0.5 sm:contents">
              <dt className="text-muted-foreground">{t(labelKey)}</dt>
              <dd className="min-w-0 break-words font-medium">{value || '-'}</dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
};
